// extracted by mini-css-extract-plugin
export default {"addProductModal":"AddProductModal_addProductModal__aQS9v","formGroup":"AddProductModal_formGroup__60S4c"};